export default __webpack_public_path__ + "static/media/push-pin-black.28a61962.png";